<template lang="pug">
  #password-setting-error
    HeaderForLogin
    b-container.pt-3
      b-card.mt-1.form-box.mx-auto.text-center.justify-content-center(body-class="px-5")
        p.mx-auto.mt-5.mb-3.white-space-pre-wrap {{error_msg}}
        .mt-5
          router-link(:to="{name: 'Login'}") ログイン画面に戻る
</template>

<script>
import HeaderForLogin from "@/components/supportSite/HeaderForLogin";

export default {
  name: "RelatedPasswordSetting",
  components: {
    HeaderForLogin
  },
  props: {
    error_msg: {type: String, required: true}
  },
}
</script>

<style scoped>
.white-space-pre-wrap {
  white-space: pre-wrap;
}
</style>